import { SharedInteractionsTableProps } from './Types/componentProps';
import { Paper, TableContainer, TableBody } from '@mui/material';
import TrackerTableHeaderRow from '../TrackerTable/TrackerTableHeaderRow';
import Table from '@mui/material/Table';
import { visibleShareIssueCols } from './Utils/constants';
import {
  TrackerDataType,
  trackerHeaderAccentSoftByType,
  trackerHeaderBlueByType,
} from '../../shared/constants/constants';
import TablePagination from '@mui/material/TablePagination';
import SharedInteractionsDataRow from './SharedInteractionsDataRow';
import React, { useEffect, useState } from 'react';
import { SharedCollaborationGroupInteractionsDataIssue } from './Types/apiData';
import Spinner from 'react-bootstrap/Spinner';

const { MEDIA_INTERACTION, SERVICE } = TrackerDataType;
const mediaAccent = trackerHeaderAccentSoftByType[MEDIA_INTERACTION];
const sharedHeaderBlue = trackerHeaderBlueByType[SERVICE];

const SharedInteractionsTable = (props: SharedInteractionsTableProps) => {
  const { issues, totalCount, page, pageSize, onPageChange, onPageSizeChange } = props;

  const [paginatedRows, setPaginatedRows] = useState<SharedCollaborationGroupInteractionsDataIssue[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);

    const timeout = setTimeout(() => {
      const startIndex = page * pageSize;
      const endIndex = startIndex + pageSize;
      setPaginatedRows(issues.slice(startIndex, endIndex));
      setIsLoading(false);
    }, 150);

    return () => clearTimeout(timeout);
  }, [issues, page, pageSize]);

  if (isLoading) {
    return (
      <div className="spinner-container">
        <Spinner animation="border" />
      </div>
    );
  }

  return (
    <>
      <TableContainer
        component={Paper}
        sx={{
          borderRadius: '10px',
          width: '100%',
          border: '2px solid #B1B9C9',
          borderTop: `2px solid ${mediaAccent}`,
          mx: 'auto',
          maxHeight: '75vh',
          mt: '10px',
          overflow: 'auto',
          scrollbarWidth: 'thin',
          scrollbarColor: '#C5CCD8 transparent',
          '&::-webkit-scrollbar': {
            width: '8px',
            height: '8px',
          },
          '&::-webkit-scrollbar-track': {
            backgroundColor: 'transparent',
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#C5CCD8',
            borderRadius: '999px',
            border: '2px solid transparent',
            backgroundClip: 'content-box',
          },
          '&::-webkit-scrollbar-thumb:hover': {
            backgroundColor: '#AFB8C7',
          },
        }}
      >
        <Table stickyHeader sx={{ minWidth: 0, m: 0 }}>
          <TrackerTableHeaderRow columns={visibleShareIssueCols} type={MEDIA_INTERACTION} tabColor={sharedHeaderBlue} />
          <TableBody>
            {paginatedRows.map((issue, index) => (
              <SharedInteractionsDataRow key={issue.id} issue={issue} rowIndex={index} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[25, 50, 100, 150]}
        component="div"
        count={totalCount}
        rowsPerPage={pageSize}
        page={page}
        onPageChange={(_event, page) => onPageChange(page)}
        onRowsPerPageChange={(event) => onPageSizeChange(parseInt(event.target.value, 10))}
        sx={{ mr: '2%' }}
      />
    </>
  );
};

export default SharedInteractionsTable;
